import { irwin } from 'config'
import { httpClient } from './httpClient'
import Jsona, { SwitchCaseJsonMapper } from 'jsona'

const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

async function createCustomerLocation({ customerId, locationId }) {
  const response = await client().post('v2/customer_locations', {
    customer_id: customerId,
    location_id: locationId,
  })
  return deserializer.deserialize(response)
}

async function updateCustomerLocation({ id, locationId }) {
  const response = await client().put(`v2/customer_locations/${id}`, {
    location_id: locationId,
  })
  return deserializer.deserialize(response)
}

async function deleteCustomerLocation(id) {
  await client().delete(`v2/customer_locations/${id}`)
}

export { createCustomerLocation, updateCustomerLocation, deleteCustomerLocation }
